export default {
  page_title: 'Donors of HKLII',
  curr: 'Current Donors',
  past: 'Past Donors',
  indi: 'Individuals',
  firm: 'Law Firms',
  intro: [
    'HKLII is thankful for the following individuals and law firms for their generous donation to support HKLII to provide free access to Hong Kong legal information: '
  ],
  donation_page: 'donation page',
  thanks: [
    'HKLII would like to thank all of our donors for contributing to the success of HKLII. If you are interested in donating HKLII, please go to our {0}. If you have any enquiries, please contact us at {1} page.'
  ]
}